import type { Shot } from "./ProductShot";
import aiSummary from "../../../images/platform/product-ai-summary.webp";
import engagementTracking from "../../../images/platform/product-engagement-tracking.webp";
import learningJourney from "../../../images/platform/product-learning-journey.webp";
import learningJourneyMatching from "../../../images/platform/product-learning-journey-matching.webp";
import mentorMatching from "../../../images/platform/product-mentor-matching.webp";
import programmeSetup from "../../../images/platform/product-programme-setup.webp";
import reports from "../../../images/platform/product-reports.webp";
import sessionManagement from "../../../images/platform/product-session-management.webp";

// Intrinsic dimensions are carried with each file so every shot reserves its space before it
// loads; without them the page reflows five times on the way down.
export const SHOTS = {
  programmeSetup: {
    title: "Programme setup and onboarding",
    src: programmeSetup,
    alt: "Programme setup and onboarding interface with participant roles and agenda",
    width: 1254,
    height: 1254,
  },
  learningJourney: {
    title: "Personalised learning journey",
    src: learningJourney,
    alt: "FutureLab learning journey interface for selecting a SMART goal and development path",
    width: 1800,
    height: 1470,
  },
  mentorMatching: {
    title: "Smart matching engine",
    src: mentorMatching,
    alt: "FutureLab smart matching interface with ranked mentor recommendations and match insight",
    width: 1254,
    height: 1254,
  },
  learningJourneyMatching: {
    title: "Participant matching view",
    src: learningJourneyMatching,
    alt: "FutureLab participant learning journey with a goal-aligned mentor recommendation",
    width: 1266,
    height: 1800,
  },
  sessionManagement: {
    title: "Scheduling and session management",
    src: sessionManagement,
    alt: "FutureLab scheduling interface with calendar, session status and booking details",
    width: 1254,
    height: 1254,
  },
  engagementTracking: {
    title: "Programme and engagement tracking",
    src: engagementTracking,
    alt: "FutureLab programme tracking interface with pairing health, ratings and session details",
    width: 1254,
    height: 1254,
  },
  aiSummary: {
    title: "Growth reports and next steps",
    src: aiSummary,
    alt: "FutureLab growth report interface with session summary, development tasks and progress",
    width: 1254,
    height: 1254,
  },
  reports: {
    title: "Reports and dashboards",
    src: reports,
    alt: "FutureLab analytics dashboard with completed sessions, engagement, feedback and goal progress",
    width: 1254,
    height: 1254,
  },
} satisfies Record<string, Shot>;
